<template>
  <div class="flex box-border rounded card shadow-theme w-full h-full overflow-hidden statistics-setting">
    <div class="left-main-content">
      <div class="flex items-center justify-between top-header px-4 bg-white">
        <el-button
          v-if="statTable.length < 1"
          class="addCrossBtn"
          type="primary"
          @click="openCreate"
        >
          新建指标统计表</el-button
        >
        <template v-else>
          <el-select
            @focus="setMinWidth"
            style="width: 216px"
            class="cross-list"
            v-model="reportValue"
            placeholder="请选择"
            @change="changeReport"
            ref="openCreateRef"
          >
            <el-option-group class="group1">
              <div @mousewheel="scrollSelect">
                <el-option
                  v-for="item in statTable"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  :style="{ 'min-width': minWidth + 'px' ,padding: '0 12px'}"
                >
                  <el-popover
                    class="selectPopover"
                    placement="right-start"
                    trigger="hover"
                    popper-class="operation-pop"
                    :modal-append-to-body="false"
                    :visible-arrow="false"
                  >
                    <div class="wordStyle renameStyle" @click="renameStatTable(item.id, item.name)">重命名</div>
                    <div class="wordStyle renameStyle" @click="deleteStatTable(item.id)">删除</div>
                    <div slot="reference" class="flex justify-between">
                      <span class="overStyle">{{ item.name }}</span>
                      <i style="line-height: 38px; margin-right: -3px" class="el-icon-arrow-right"></i>
                    </div>
                  </el-popover>
                </el-option>
              </div>
            </el-option-group>
            <el-option-group class="group2">
              <i class="px-3 pb-2 el-icon-plus wordStyle2" @click="openCreate('ref')"
                ><span class="wordStyle2" style="margin-left: 3px">新建指标统计表</span></i
              >
            </el-option-group>
          </el-select>
          <div class="right-copy flex text-theme-black-450 items-center">
            <!-- <div v-if="showProgress" class="mr-2 wrap-refresh-progress">
              <el-progress :percentage="refreshProgress"></el-progress>
            </div>
            <div class="flex items-center text-sm text-theme-black-650 mr-2" v-else>
              <span>数据截至：{{refreshDate}}</span>
              <img class="ml-1" src="@/assets/img/index-stat/refresh.png" alt="" @click="clickRefresh">
            </div> -->
            <p>访问地址：</p>
            <div class="copy-link flex">
              <span class="flex-1 px-3">{{previewUrl}}</span>
              <div class="copy-btn"><i class="el-icon-document-copy" @click="copyFn"></i></div>
            </div>
            <el-button type="primary" class="ml-4 previewBtn border-none text-theme-black-450" @click="toThematic({id:1})">打开</el-button>
          </div>
        </template>
      </div>
      <div class="flex h-full">
        <!-- 维度配置 -->
        <div class="dimension-config bg-white overflow-auto">
          <left-tree treetype="1" :treeData="indexTreeData" @clickTreeNode="clickIndexNode" @clickOneLevelIcon="clickIndexOneLevelIcon" @clickDimensionTiltle="clickDimensionTiltle">
          </left-tree>
          <left-tree treetype="2" :treeData="areaTreeData" @editAreaClass="editAreaClass" @clickOneLevelIcon="clickAreaOneLevelIcon">
            <template slot="one-level-icon"><i class="iconfont text-theme-black-850 icon-jc-setting text-xs hover-blue-icon cursor-pointer" @click="clickAreaOneLevelIcon"></i></template>
          </left-tree>
          <left-tree treetype="3" :treeData="timeTreeData" @clickOneLevelIcon="clickTimeOneLevelIcon">
            <template slot="one-level-icon"><i class="iconfont text-theme-black-850 icon-jc-setting text-xs hover-blue-icon cursor-pointer" @click="clickTimeOneLevelIcon"></i></template>
          </left-tree>
        </div>
        <!-- 单元格数据配置 -->
        <div class="p-4 flex-1 cell-set-container flex flex-col" >
          <div v-if="tableType==0" class="py-3 px-4 bg-white flex-1 no-table flex flex-col items-center justify-center">
            <p class="mb-4 text-20 font-semibold leading-22  text-theme-black-850">指标统计表</p>
            <p class="text-medium text-theme-black-650 leading-22 font-normal">搭建指标体系，关联调查数据，自动计算指标</p>
            <p class="text-medium text-theme-black-650 leading-22 font-normal">助你实时掌握指标值实时数据、变化趋势，指导日常工作</p>
            <p class="text-medium text-theme-black-650 leading-22 font-normal">应用场景：客户满意度各指标结果报表、企业各经营指标时间趋势报表等</p>
            <el-button
            v-if="statTable.length < 1"
            class="addCrossBtn mt-4"
            type="primary"
            @click="openCreate"
          >
            新建指标统计表</el-button
          >
            <img class="mt-8" src="@/assets/img/index-stat/index-tip.png" alt="">
          </div>
          <!-- <div v-else-if="tableType==0" class="h-full no-table flex flex-col items-center justify-center">
            <p class="mb-4">配置【指标】、【地区】、【时间】这 3 个统计维度</p>
            <p>完成配置，点击次末级指标进行单元格数据配置，点击【指标】查看单元格配置进度</p>
          </div> -->
          <div v-else-if="tableType==1" class="py-3 px-4 bg-white overflow-y-auto flex-1">
            <p class="mb-3 text-medium font-semibold leading-22  text-theme-black-850">指标数值配置</p>
            <overview-table ref="overviewTable" :reportValue="reportValue"></overview-table>
          </div>
          <div v-else-if="tableType==2" class="py-3 px-4 bg-white overflow-y-auto flex-1">
            <p class="mb-3 text-medium font-semibold leading-22  text-theme-black-850">指标数值配置</p>
            <cell-table ref="cellTable" :indexNodeId="indexNodeId"></cell-table>
          </div>
          <p class="text-xs text-theme-black-250 text-center h-10 leading-10">Copyright &#169 2010-2022 调研工厂 使用即表示同意 用户协议 | 隐私政策 |     已通过ISO27001信息安全认证</p>
        </div>
      </div>
    </div>
    <!-- 侧边提示 -->
    <div class="py-4 pr-4 overflow-y-auto overflow-x-hidden right-tip-word bg-white box-border">
      <h4 class="mb-2">指标统计表</h4>
      <p>以国家统计局数据报表为例：</p>
      <img src="@/assets/img/index-stat/index-tip.png" alt="">
      <p>通过构建指标、地区、时间 3 个维度，关联相关数据后，可分析各地区、各指标的时间变化趋势。</p>
      <p><span v-custom="'out_D74'">调研工厂</span>指标统计表支持通过构建指标、地区、时间，构建公司客户满意度各指标结果报表、各经营指标指标时间趋势报表等。</p>
    </div>
    <!-- 添加/编辑地区分类 -->
    <div class="wrap-index-stat-drawer">
      <el-drawer
        title="地区"
        :visible.sync="drawerArea"
        size='80%'
        :before-close="handleCloseArea"
        custom-class="wrap-head-16">
        <add-area ref="addArea" @closeAreaDrawer="closedrawerArea" @updataCellTable="updataCellTable"/>
      </el-drawer>
    </div>
    <!-- 批量添加指标弹窗 -->
    <add-index-drawer :visibleIndexDrawer.sync="visibleIndexDrawer" @updataCellTable="updataCellTable"/>
    <!-- 新建统计表弹窗 -->
    <rename-dialog :renameDialog.sync="renameDialog" :dialogParams="dialogParams" :addStatId.sync="addStatId"/>
    <!-- tip提示弹框 -->
    <setting-tip-dialog :tipDialog.sync="tipDialog" tipName="cell" />
    <!-- 确认删除统计表弹框 -->
    <el-dialog
      title=""
      :visible.sync="delDialogVisible"
      width="30%"
      @close="delDialogVisible=false">
      <p>删除后，所有配置数据不可恢复</p>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="delDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureDelete">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 管理时间维度 -->
    <add-time :addTimeShow.sync="addTimeShow" @updataCellTable="updataCellTable"></add-time>
  </div>
</template>

<script>
import LeftTree from './components/LeftTree.vue'
import AddIndexDrawer from './components/AddIndexDrawer.vue'
import RenameDialog from './components/RenameDialog.vue';
import SettingTipDialog from './components/SettingTipDialog';
import AddTime from './components/AddTime.vue';
import AddArea from './components/AddArea.vue'
import OverviewTable from './components/OverviewTable.vue'
import CellTable from './components/CellTable.vue'
import { copyText } from '@dygc/shared'
import mixin from './mixin.js'
import { mapGetters } from 'vuex'
import { indicatorStatisticsQueryList, indicatorStatisticsDel } from '@/api/index-statistics'
export default {
  name: 'indexSetting',
  mixins: [mixin],
  components: {LeftTree, AddIndexDrawer, RenameDialog,AddArea,AddTime, SettingTipDialog,OverviewTable,CellTable},
  data() {
    return {
      tableType:0,
      statTable: [], //
      minWidth: '',
      timer: '',
      dialogParams: {},
      renameDialog: false,
      reportValue: '',
      visibleIndexDrawer: false, //添加指标弹框
      delDialogVisible: false, //确认删除统计表框
      curDelStatId: '', //当前删除的统计表id
      tipDialog: false,
      drawerArea:false,//添加地区分类
      indexTreeData: [],
      indexNodeId:0,
      addTimeShow:false,
      nextLastNode:'',//次末级指标节点
      addStatId: '',
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
    previewUrl(){
      return window.origin + process.env.VUE_APP_PRE_URL + '/#/index-statistics/data/'+this.reportValue
    }
  },
  created() {},
  mounted() {
    this.getStatList()
  },
  watch: {
  },
  methods: {
    updataCellTable(){
      if(this.tableType==0){
        this.changeTableType()
      }
      if(this.tableType==1){
        this.$refs.overviewTable.getTableData()
      }
      if(this.tableType==2){
        this.$refs.cellTable.getTableData()
      }
    },
    async changeTableType(){
      await this.getDimensionFinish()
      if(this.isDimensionComplete){
        this.tableType=1
      }
    },
    async clickRefresh(){
      await this.getConfigFinshed()
      if(this.isConfigComplete){
        this.refreshData()
      }else{
        this.$message.warning('未完成【指标】、【时间】这2个维度以及所有的【单元格数据】配置前，不支持刷新')
      }
    },
    format(percentage) {
      return `${percentage}%`;
    },
    getTreeFn(){
      this.getIndexDimensionList()
      this.getAreaDimensionList()
      this.getTimeDimensionList()
      this.getRefreshDataDate()
    },
    // 获取指标统计表列表
    async getStatList(){
      try {
        const data = await indicatorStatisticsQueryList()
        this.statTable = data.data.data
      } catch(e) {
        this.statTable = []
      } finally {
        if(this.reportValue != this.curDelStatId && this.curDelStatId){
          // 删除非当前报表 不更新reportValue
        }else{
          this.reportValue = this.statTable[0]?.id
          // 新建或重命名传入
          if (this.addStatId) {
            this.reportValue = this.addStatId.id
          }
        }
        
        const curStat = this.statTable.find(item => item.id == this.reportValue)
        this.$store.commit('SET_INDEX_STAT_INFO',Object.assign(this.indexStatInfo || {},curStat))
        if(this.reportValue) {
          this.getTreeFn()
          this.changeTableType()
        }
        this.curDelStatId = ''
      }
    },
    handleCloseArea() {
      this.drawerArea = false
      this.$refs.addArea.areaDataObj = {}
    },
    async toThematic() {
      await this.getConfigFinshed()
      if(!this.isConfigComplete){
        this.$message.warning('未完成【指标】、【时间】这2个维度以及所有的【单元格数据】配置前，不支持预览')
        return
      }
      if(this.reportValue)
        window.open(this.previewUrl)
        // this.$router.push({
        //   path: `/index-statistics/data/${this.reportValue}`
        // })
    },
    // 设置下拉菜单宽度
    setMinWidth(val) {
      this.minWidth = val.srcElement.clientWidth
    },
    scrollSelect() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.statTable.forEach(item => {
          item.showPopOver = false
        })
      }, 200)
    },
    renameStatTable(id, name) {
      this.dialogParams = {
        title: '编辑指标统计表名称',
        id: id,
        name: name
      }
      this.renameDialog = true
    },
    deleteStatTable(id) {
      this.delDialogVisible = true
      this.curDelStatId = id
    },
    sureDelete() {
      indicatorStatisticsDel({
        id: this.curDelStatId
      }).then(res => {
        if(res.data.code == 0 && res.data.data) {
          this.$message.success('删除成功!')
          this.getStatList()
          this.addStatId = ''
        }else{
          this.$message.error('删除失败!')
        }
      }).finally(() => {
        this.getTreeFn()
        this.tableType = 0
        this.updataCellTable()
      })
      this.delDialogVisible = false
    },
    openCreate(name) {
      this.dialogParams = {
        title: '新建指标统计表',
        id: '',
        name: ''
      }
      this.renameDialog = true
      if (name == 'ref') this.$refs.openCreateRef.blur()
    },
    async changeReport() {
      this.statTable.forEach(item => {
        item.showPopOver = false
      })
      const curStat = this.statTable.find(item => item.id == this.reportValue)
      this.$store.commit('SET_INDEX_STAT_INFO',Object.assign(this.indexStatInfo || {},curStat))
      await this.getDimensionFinish()
      if(this.isDimensionComplete){
        this.tableType=1
        this.$nextTick(()=>{
          this.$refs.overviewTable.getTableData()
        })
      }else{
        this.tableType = 0
      }
      this.getTreeFn()
    },
    //点击指标节点
   async clickIndexNode(data){
      if(data.fatherId==0 && !data.hasChild){
        await this.getDimensionFinish()
        if(!this.isDimensionComplete){
          this.$message.warning('未完成【指标】、【时间】这2个维度配置前，不支持单元格配置')
          return
        }
        this.tableType=2
        this.indexNodeId=data.id
      }else if(data.hasChild){
        let arr=data.children.filter(val=>!val.hasChild)
        if(arr.length>0){
          await this.getDimensionFinish()
          if(!this.isDimensionComplete){
            this.$message.warning('未完成【指标】、【时间】这2个维度配置前，不支持单元格配置')
            return
          }
          this.tableType=2
          this.indexNodeId=data.id
        }
      }
    },
    async clickDimensionTiltle(){
      await this.getDimensionFinish()
      if(!this.isDimensionComplete){
        this.$message.warning('未完成【指标】、【时间】这2个维度配置前，不支持单元格配置')
        return
      }
      this.tableType=1
    },
    //点击指标根节点icon 批量添加指标
    clickIndexOneLevelIcon(data){
      if(!this.reportValue) {
        // this.$message.warning('请先新建指标统计表！')
        this.dialogParams = {
          title: '新建指标统计表',
          id: '',
          name: '',
          isNew: true
        }
        this.renameDialog = true
        return
      }
      this.visibleIndexDrawer = true
    },
    //编辑地区分类
    editAreaClass(data){
      this.drawerArea = true
    },
    //添加地区分类
    clickAreaOneLevelIcon(){
      if(!this.reportValue) {
        // this.$message.warning('请先新建指标统计表！')
        this.dialogParams = {
          title: '新建指标统计表',
          id: '',
          name: '',
          isNew: true
        }
        this.renameDialog = true
        return
      }
      this.drawerArea = true
      this.$nextTick(() => {
        this.$refs.addArea.initFn()
      })
    },
    //关闭地区分类
    closedrawerArea(){
      this.drawerArea = false
    },
    clickTimeOneLevelIcon(){
      if(!this.reportValue) {
        // this.$message.warning('请先新建指标统计表！')
        this.dialogParams = {
          title: '新建指标统计表',
          id: '',
          name: '',
          isNew: true
        }
        this.renameDialog = true
        return
      }
      this.addTimeShow = true
    },
    copyFn(){
      copyText('.copy-btn', this.previewUrl)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    openTipDialog() {
      this.tipDialog = true
    },
    relateForm(data){
      console.log(data)
    },
    addArea(data){
      console.log(data)
    }
  }
}
</script>

<style lang="scss">
.text-theme-color{
  @apply text-theme;
}
/* 修改交叉列表下拉菜单的 重命名和删除样式 */
.el-popover.operation-pop {
  width: 160px !important;
  min-width: 160px !important;
  line-height: 38px;
  padding: 8px 0;
  /* position: absolute;
  left:10px;
  top:10px; */
  margin-left: 16px;
  margin-bottom: -28px;
}
.left-main-content{
  width: calc(100% - 290px);
}
.right-tip-word{
  width: 290px;
  h4{
    height: 20px;
    // border-left: 4px solid #2775E8;
    @apply border-l-4 border-solid border-theme;
    padding-left: 13px;
    line-height: 20px;
  }
  p{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
    padding-left: 17px;
    margin: 8px 0;
  }
  img{
    width: 258px;
    margin: 0px 17px;
  }
  .line-show{
    width: 258px;
    height: 1px;
    background: #E7E9EB;
    margin: 16px;
  }
}
.el-select-group__wrap:not(:last-of-type)::after{
  left: 0 !important;
  right: 0 !important;
  color: rgba($color: #F2F5FA, $alpha: 0.5) !important;
}
.wordStyle {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
}
.renameStyle {
  line-height: 38px;
  padding-left: 12px;
}

.renameStyle:hover {
  background-color: #f2f5fa;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  @apply text-theme;
}
.wrap-refresh-progress{
  .el-progress.el-progress--line{
    width: 150px !important;
  }
}
</style>
<style lang="scss" scoped>
.dimension-config{
  border-right: 1px solid #e7e9e8;
}
.statistics-setting {
  background: #F7F9FB;
  .router-link-active {
    @apply text-theme border-theme border-b-2 border-solid;
  }
}
::v-deep .el-dialog__footer {
  padding: 16px;
  .el-button {
    width: 88px;
    height: 32px;
  }

  .cancel {
    border: 1px solid #ccc;
    color: rgba(0, 0, 0, 0.45);
  }
}
.wordStyle2 {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  @apply text-theme;
  margin-right: 3px;
  cursor: pointer;
}
.overStyle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.top-header {
  height: 56px;
  border-bottom: 1px solid #E7E9EB;
  .addCrossBtn {
    width: 130px;
    height: 32px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .right-copy{
    font-size: 14px;
    line-height: 32px;
    .copy-link{
      width: 256px;
      height: 32px;
      border-radius: 2px;
      span{
        display: inline-block;
        border: 1px solid #F2F5FA;
        border-right: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .copy-btn{
        width: 32px;
        height: 32px;
        background: #F2F5FA;
        border-radius: 0 2px 2px 0;
        text-align: center;
      }
    }
    .previewBtn{
      width: 60px;
      height: 32px;
      background: #F2F5FA;
      border-radius: 2px;
      
    }
  }
}
.group1 {
  line-height: 34px;
  padding-bottom: 42px;
}

.group2 {
  background-color: #fff;
  width: 100%;
  position: absolute;
  bottom: 0px;
  height: 40px;
  line-height: 40px;
  border-top: 1px solid rgba($color: #f2f5fa, $alpha: 0.5);
}
.right-tip-word{
  border-left: 1px solid #e7e9e8;
  height: calc(100vh - 54px);
}
.cell-set-container{
  height: calc(100vh - 127px);
  overflow: auto;
  // height: calc(100vh - 200px);
}

</style>
